import { Color } from "./LimpaCanvas";

export type Palette = Color[];

// Both C64 palettes found in this thread:
// https://www.lemon64.com/forum/viewtopic.php?t=8718&sid=b63e87376858ad025d64d07fb7d6feff
export const c64: Palette = [
  [0x00, 0x00, 0x00, 0xff],
  [0xff, 0xff, 0xff, 0xff],
  [0x88, 0x20, 0x00, 0xff],
  [0x68, 0xd0, 0xa8, 0xff],
  [0xa8, 0x38, 0xa0, 0xff],
  [0x50, 0xb8, 0x18, 0xff],
  [0x18, 0x10, 0x90, 0xff],
  [0xf0, 0xe8, 0x58, 0xff],
  [0xa0, 0x48, 0x00, 0xff],
  [0x47, 0x2b, 0x1b, 0xff],
  [0xc8, 0x78, 0x70, 0xff],
  [0x48, 0x48, 0x48, 0xff],
  [0x80, 0x80, 0x80, 0xff],
  [0x98, 0xff, 0x98, 0xff],
  [0x50, 0x90, 0xd0, 0xff],
  [0xb8, 0xb8, 0xb8, 0xff]
];

export const c64alt: Palette = [
  [0x00, 0x00, 0x00, 0xff],
  [0xff, 0xff, 0xff, 0xff],
  [0x68, 0x37, 0x2b, 0xff],
  [0x70, 0xa4, 0xb2, 0xff],
  [0x6f, 0x3d, 0x86, 0xff],
  [0x58, 0x8d, 0x43, 0xff],
  [0x35, 0x28, 0x79, 0xff],
  [0xb8, 0xc7, 0x6f, 0xff],
  [0x6f, 0x4f, 0x25, 0xff],
  [0x43, 0x39, 0x00, 0xff],
  [0x9a, 0x67, 0x59, 0xff],
  [0x44, 0x44, 0x44, 0xff],
  [0x6c, 0x6c, 0x6c, 0xff],
  [0x9a, 0xd2, 0x84, 0xff],
  [0x6c, 0x5e, 0xb5, 0xff],
  [0x95, 0x95, 0x95, 0xff]
];
